


import { Component, Vue } from 'vue-property-decorator';
import { RouteNames } from '../../../../utils/router/router.models';
import { ContactType } from '../ContactForm/ContactForm.models';

@Component({
  components: {}
})
export default class ContactConfirmation extends Vue {
  public RouteNames = RouteNames;

  public image = require('@/assets/images/contact/confirmation.jpg');

  public get textSet() {
    return this.$route.query.type === (ContactType.Offer.toString() as string) ? 'offer' : 'default';
  }
}
